"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestigadorLineaPersonalizadaSchema = exports.InvestigadorLineaOptionSchema = exports.InvestigadorPublicLineaSchema = exports.InvestigadorPublicUnidadSchema = exports.FotoPerfilResponseSchema = exports.RolMostradoResponseSchema = exports.SetRolMostradoSchema = exports.InvestigadorPublicPerfilSchema = exports.InvestigadorPublicIdentitySchema = exports.InvestigadorEnlaceIdParamSchema = exports.InvestigadorSlugParamSchema = exports.RestoreInvestigadorDatosPersonalesSchema = exports.ReorderDatosPersonalesSchema = exports.InvestigadorDatoPersonalIdParamSchema = exports.UpdateInvestigadorDatoPersonalSchema = exports.CreateInvestigadorDatoPersonalSchema = exports.AdscripcionContextoResponseSchema = exports.InvestigadorAdscripcionResponseSchema = exports.UpdateInvestigadorAdscripcionSchema = exports.UnidadesCatalogoResponseSchema = exports.UnidadCatalogoItemSchema = exports.InvestigadorDatosPersonalesResponseSchema = exports.InvestigadorUnidadActualSchema = exports.InvestigadorDatoPersonalSchema = exports.TipoDatoPersonalListResponseSchema = exports.TipoDatoPersonalSchema = exports.InvestigadorCapitalHumanoIdParamSchema = exports.ReorderInvestigadorCapitalHumanoSchema = exports.UpdateInvestigadorCapitalHumanoSchema = exports.CreateInvestigadorCapitalHumanoSchema = exports.InvestigadorPremioIdParamSchema = exports.ReorderInvestigadorPremiosSchema = exports.UpdateInvestigadorPremioSchema = exports.CreateInvestigadorPremioSchema = exports.InvestigadorActividadIdParamSchema = exports.RestoreInvestigadorActividadesSchema = exports.ReorderInvestigadorActividadesSchema = exports.UpdateInvestigadorActividadSchema = exports.CreateInvestigadorActividadSchema = exports.InvestigadorActividadInputSchema = exports.RestoreInvestigadorEnlacesExternosSchema = exports.ReplaceInvestigadorEnlacesExternosSchema = exports.ReorderInvestigadorEnlacesExternosSchema = exports.UpdateInvestigadorEnlaceExternoSchema = exports.CreateInvestigadorEnlaceExternoSchema = exports.InvestigadorEnlaceExternoInputSchema = exports.UpdateNombrePerfilResponseSchema = exports.UpdateNombrePerfilSchema = exports.FormatoNombreInvestigadorSchema = exports.UpdatePerfilSchema = void 0;
exports.AdminInvestigadorListResponseSchema = exports.AdminInvestigadorItemSchema = exports.VisibilidadPublicaSchema = exports.InvestigadorDirectoryResponseSchema = exports.InvestigadorDirectoryItemSchema = exports.InvestigadorDirectoryPerfilSchema = exports.InvestigadorPublicProfileResponseSchema = exports.DatoPersonalPublicoSchema = exports.InvestigadorPublicCvSchema = exports.InvestigadorProyectoSchema = exports.InvestigadorPublicacionSchema = exports.InvestigadorEnlacesExternosResponseSchema = exports.InvestigadorEditableEnlaceSchema = exports.InvestigadorPublicEnlaceSchema = exports.RestoreInvestigadorFormacionSchema = exports.InvestigadorFormacionResponseSchema = exports.InvestigadorEditableFormacionSchema = exports.InvestigadorFormacionIdParamSchema = exports.ReorderInvestigadorFormacionSchema = exports.UpdateInvestigadorFormacionSchema = exports.CreateInvestigadorFormacionSchema = exports.RestoreInvestigadorExperienciaSchema = exports.InvestigadorExperienciaResponseSchema = exports.InvestigadorEditableExperienciaSchema = exports.InvestigadorExperienciaIdParamSchema = exports.UpdateInvestigadorExperienciaSchema = exports.CreateInvestigadorExperienciaSchema = exports.RestoreInvestigadorCargosSchema = exports.InvestigadorCargosResponseSchema = exports.AlertaGeneradaSchema = exports.InvestigadorEditableCargoSchema = exports.InvestigadorCargoIdParamSchema = exports.UpdateInvestigadorCargoSchema = exports.CreateInvestigadorCargoSchema = exports.RestoreInvestigadorCapitalHumanoSchema = exports.InvestigadorCapitalHumanoResponseSchema = exports.InvestigadorEditableCapitalHumanoSchema = exports.RestoreInvestigadorPremiosSchema = exports.InvestigadorPremiosResponseSchema = exports.InvestigadorEditablePremioSchema = exports.InvestigadorActividadesResponseSchema = exports.InvestigadorEditableActividadSchema = exports.InvestigadorPublicActividadSchema = exports.InvestigadorPublicCargoSchema = exports.InvestigadorPublicPremioSchema = exports.InvestigadorPublicCapitalHumanoSchema = exports.InvestigadorPublicExperienciaSchema = exports.InvestigadorPublicFormacionSchema = exports.UpdateInvestigadorLineasSchema = exports.InvestigadorLineasStateResponseSchema = void 0;
exports.InvestigadorPublicacionOptionsResponseSchema = exports.InvestigadorPublicacionesResponseSchema = exports.InvestigadorBasicOptionSchema = exports.InvestigadorTipoPublicacionOptionSchema = exports.InvestigadorEstamentoOptionSchema = exports.InvestigadorPublicacionDetailSchema = exports.PublicacionParticipanteDetailSchema = exports.InvestigadorPublicacionRowSchema = exports.BulkSetEstamentoPublicacionesSchema = exports.BulkSetLineaPublicacionesSchema = exports.BulkDeletePublicacionesSchema = exports.ReportarErrorPublicacionSchema = exports.ReportarInvestigadorFaltanteSchema = exports.InvestigadorPublicacionIdParamSchema = exports.UpdateInvestigadorPublicacionSchema = exports.CreateInvestigadorPublicacionSchema = exports.UpdateSolicitudEstadoSchema = exports.SolicitudesListResponseSchema = exports.SolicitudResponseSchema = exports.SolicitudUsuarioInfoSchema = exports.CreateSolicitudSchema = exports.CreateSolicitudAdscripcionSchema = exports.CreateSolicitudCambioUnidadDetallesSchema = exports.AdminVisibilidadUpdateResponseSchema = exports.SetInvestigadorVisibilidadSchema = void 0;
const zod_1 = require("zod");
const fecha_precision_js_1 = require("./fecha-precision.js");
const adscripcion_js_1 = require("./adscripcion.js");
const publicacion_lineas_js_1 = require("./publicacion-lineas.js");
const lineas_display_js_1 = require("./lineas-display.js");
const NullableStringSchema = zod_1.z.string().nullable();
const NullableNumberSchema = zod_1.z.number().nullable();
const NullableBooleanSchema = zod_1.z.boolean().nullable();
// Snapshots de "deshacer cambios": el pipeline de edición representa los campos
// opcionales vacíos como `undefined`, y `JSON.stringify` elimina esas claves, así
// que el payload llega con la clave AUSENTE (no `null`). Un `z.string().nullable()`
// acepta `null` pero rechaza la ausencia. Este helper toma un schema de item editable
// y, para cada campo nullable, acepta también la ausencia coalesciéndola a `null`.
// El tipo de salida sigue siendo `T | null`, por lo que los services no cambian.
function restoreSnapshotItem(base) {
    const shape = base.shape;
    const nextShape = {};
    for (const [key, field] of Object.entries(shape)) {
        nextShape[key] =
            field instanceof zod_1.z.ZodNullable ? field.optional().transform((value) => value ?? null) : field;
    }
    return zod_1.z.object(nextShape);
}
const TipoCargoSchema = zod_1.z.enum(['directivo', 'academico', 'administrativo']);
const TipoParticipacionCapitalHumanoSchema = zod_1.z.enum([
    'guia_principal',
    'co_guia',
    'tutor',
    'mentor',
    'comision',
    'otro',
]);
const NivelFormacionCapitalHumanoSchema = zod_1.z.enum([
    'pregrado',
    'magister',
    'doctorado',
    'postdoctorado',
    'especialidad',
    'otro',
]);
const CategoriaActividadSchema = zod_1.z.enum([
    'difusion',
    'transferencia',
    'divulgacion',
    'extension',
    'membresia',
    'comite_editorial',
    'evaluacion',
    'jurado',
    'organizacion_evento',
    'ponencia',
    'charla',
    'otro',
]);
const TipoEnlaceSchema = zod_1.z.enum([
    'orcid',
    'anid',
    'google_scholar',
    'scopus',
    'wos',
    'researchgate',
    'linkedin',
    'github',
    'sitio_personal',
    'laboratorio',
    'otro',
]);
exports.UpdatePerfilSchema = zod_1.z.object({
    biografia: zod_1.z.string().max(400).optional().nullable(),
    ciudadPublica: zod_1.z.string().max(128).optional().nullable(),
    paisPublico: zod_1.z.string().max(128).optional().nullable(),
});
// ───────────── Nombre del perfil (tabla investigador) ─────────────
exports.FormatoNombreInvestigadorSchema = zod_1.z.enum([
    'primer_nombre',
    'segundo_nombre',
    'nombre_compuesto',
    'nombre_invertido',
]);
const formatosQueRequierenSegundoNombre = [
    'segundo_nombre',
    'nombre_compuesto',
    'nombre_invertido',
];
exports.UpdateNombrePerfilSchema = zod_1.z
    .object({
    nombre1: zod_1.z.string().trim().min(1, 'El primer nombre es requerido').max(150),
    nombre2: zod_1.z.string().trim().max(150).optional().nullable(),
    apellido1: zod_1.z.string().trim().min(1, 'El primer apellido es requerido').max(150),
    apellido2: zod_1.z.string().trim().max(150).optional().nullable(),
    formatoNombre: exports.FormatoNombreInvestigadorSchema,
})
    .refine((data) => !formatosQueRequierenSegundoNombre.includes(data.formatoNombre) || Boolean(data.nombre2 && data.nombre2.trim()), { message: 'El formato elegido necesita un segundo nombre', path: ['formatoNombre'] });
exports.UpdateNombrePerfilResponseSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    previousSlug: zod_1.z.string().optional(),
    displayName: zod_1.z.string(),
    fullName: zod_1.z.string(),
    nombre1: zod_1.z.string(),
    nombre2: NullableStringSchema,
    apellido1: zod_1.z.string(),
    apellido2: NullableStringSchema,
    formatoNombre: exports.FormatoNombreInvestigadorSchema,
});
exports.InvestigadorEnlaceExternoInputSchema = zod_1.z.object({
    id: zod_1.z.number().int().positive().optional(),
    tipoEnlace: TipoEnlaceSchema,
    etiqueta: zod_1.z.string().max(255).optional().nullable(),
    url: zod_1.z.string().url().max(1024),
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.CreateInvestigadorEnlaceExternoSchema = zod_1.z.object({
    tipoEnlace: TipoEnlaceSchema,
    etiqueta: zod_1.z.string().max(255).optional().nullable(),
    url: zod_1.z.string().url().max(1024),
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.UpdateInvestigadorEnlaceExternoSchema = zod_1.z.object({
    tipoEnlace: TipoEnlaceSchema,
    etiqueta: zod_1.z.string().max(255).optional().nullable(),
    url: zod_1.z.string().url().max(1024),
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.ReorderInvestigadorEnlacesExternosSchema = zod_1.z.object({
    orden: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
exports.ReplaceInvestigadorEnlacesExternosSchema = zod_1.z.object({
    enlaces: zod_1.z.array(exports.InvestigadorEnlaceExternoInputSchema),
});
// Deshacer cambios: snapshot con que se abrió el modal (todos los ítems con su id
// original y su orden). El backend reconcilia el estado actual → snapshot en una tx.
exports.RestoreInvestigadorEnlacesExternosSchema = zod_1.z.object({
    snapshot: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.number().int().positive(),
        tipoEnlace: TipoEnlaceSchema,
        etiqueta: zod_1.z.string().max(255).optional().nullable(),
        url: zod_1.z.string().url().max(1024),
        esPublico: zod_1.z.boolean(),
        ordenVisual: zod_1.z.number().int(),
    })),
});
const InvestigadorActividadRawInputSchema = zod_1.z.object({
    categoriaActividad: CategoriaActividadSchema,
    titulo: zod_1.z.string().trim().min(1).max(500),
    institucion: zod_1.z.string().max(255).optional().nullable(),
    descripcion: zod_1.z.string().optional().nullable(),
    pais: zod_1.z.string().max(128).optional().nullable(),
    ciudad: zod_1.z.string().max(128).optional().nullable(),
    fechaInicio: zod_1.z.string().date().optional().nullable(),
    fechaTermino: zod_1.z.string().date().optional().nullable(),
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    esPublico: zod_1.z.boolean().optional().default(true),
});
// Con precisión 'mes' en cualquiera de las dos fechas, el rango se compara por mes (R64).
const ensureActividadDateRange = fecha_precision_js_1.rangoFechasValido;
const actividadDateRangeOptions = {
    message: 'La fecha de término debe ser posterior o igual a la fecha de inicio',
    path: ['fechaTermino'],
};
exports.InvestigadorActividadInputSchema = InvestigadorActividadRawInputSchema.extend({
    id: zod_1.z.number().int().positive().optional(),
}).refine(ensureActividadDateRange, actividadDateRangeOptions);
exports.CreateInvestigadorActividadSchema = InvestigadorActividadRawInputSchema.refine(ensureActividadDateRange, actividadDateRangeOptions);
exports.UpdateInvestigadorActividadSchema = InvestigadorActividadRawInputSchema.refine(ensureActividadDateRange, actividadDateRangeOptions);
exports.ReorderInvestigadorActividadesSchema = zod_1.z.object({
    orden: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
// Deshacer cambios: snapshot con que se abrió el modal de actividades.
exports.RestoreInvestigadorActividadesSchema = zod_1.z.object({
    snapshot: zod_1.z.array(InvestigadorActividadRawInputSchema.extend({
        id: zod_1.z.number().int().positive(),
        ordenVisual: zod_1.z.number().int(),
    })),
});
exports.InvestigadorActividadIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
const InvestigadorPremioRawInputSchema = zod_1.z.object({
    nombrePremio: zod_1.z.string().trim().min(1).max(500),
    institucionOtorgante: zod_1.z.string().max(255).optional().nullable(),
    descripcion: zod_1.z.string().optional().nullable(),
    pais: zod_1.z.string().max(128).optional().nullable(),
    ciudad: zod_1.z.string().max(128).optional().nullable(),
    anio: zod_1.z.number().int().min(1900).max(2100).optional().nullable(),
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.CreateInvestigadorPremioSchema = InvestigadorPremioRawInputSchema;
exports.UpdateInvestigadorPremioSchema = InvestigadorPremioRawInputSchema;
exports.ReorderInvestigadorPremiosSchema = zod_1.z.object({
    orden: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
exports.InvestigadorPremioIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
const InvestigadorCapitalHumanoRawInputSchema = zod_1.z.object({
    nombrePersona: zod_1.z.string().trim().min(1).max(255),
    tituloTrabajo: zod_1.z.string().max(700).optional().nullable(),
    tipoParticipacion: TipoParticipacionCapitalHumanoSchema,
    nivelFormacion: NivelFormacionCapitalHumanoSchema,
    institucion: zod_1.z.string().max(255).optional().nullable(),
    unidadAcademica: zod_1.z.string().max(255).optional().nullable(),
    descripcion: zod_1.z.string().optional().nullable(),
    fechaInicio: zod_1.z.string().date().optional().nullable(),
    fechaTermino: zod_1.z.string().date().optional().nullable(),
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    anio: zod_1.z.number().int().min(1900).max(2100).optional().nullable(),
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.CreateInvestigadorCapitalHumanoSchema = InvestigadorCapitalHumanoRawInputSchema;
exports.UpdateInvestigadorCapitalHumanoSchema = InvestigadorCapitalHumanoRawInputSchema;
exports.ReorderInvestigadorCapitalHumanoSchema = zod_1.z.object({
    orden: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
exports.InvestigadorCapitalHumanoIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
// ───────────── Datos personales extensibles ─────────────
const TipoValorDatoPersonalSchema = zod_1.z.enum([
    'texto', 'url', 'email', 'telefono', 'numero', 'fecha', 'booleano',
]);
exports.TipoDatoPersonalSchema = zod_1.z.object({
    id: zod_1.z.number().int().positive(),
    codigo: zod_1.z.string(),
    nombre: zod_1.z.string(),
    descripcion: NullableStringSchema,
    tipoValor: TipoValorDatoPersonalSchema,
    permiteMultiples: zod_1.z.boolean(),
    esSensible: zod_1.z.boolean(),
    anchoColumnas: zod_1.z.number().int().min(1).max(3),
    activo: zod_1.z.boolean(),
});
exports.TipoDatoPersonalListResponseSchema = zod_1.z.object({
    tipos: zod_1.z.array(exports.TipoDatoPersonalSchema),
});
exports.InvestigadorDatoPersonalSchema = zod_1.z.object({
    idTipoDatoPersonal: zod_1.z.number().int().positive(),
    secuencia: zod_1.z.number().int().positive(),
    codigo: zod_1.z.string(),
    tipoValor: TipoValorDatoPersonalSchema,
    permiteMultiples: zod_1.z.boolean(),
    valorTexto: NullableStringSchema,
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number().int(),
    // R65: unit a mirror row (`unidad` / `unidad_adicional`) points at (`valor_json.idUnidad`); null for any
    // other dato or an unmapped row. Optional with a default so an older payload still passes `Schema.parse`.
    idUnidad: zod_1.z.number().int().positive().nullable().optional().default(null),
    // Afiliación tooltip: macrounidad (faculty) of the unit a mirror row points at; null for any other dato and for a
    // unit with no macrounidad ("Otra"), absent in an older payload. Optional WITHOUT a default: this schema is also
    // the snapshot item of "deshacer cambios", which never carries it.
    macrounidad: NullableStringSchema.optional(),
});
// Unidad del investigador integrada al modal de info personal: se muestra como
// una fila más (ordenable junto a los datos, pero no eliminable).
// La unidad vive como fila normal de datos personales (tipo `unidad`); este
// objeto solo expone la adscripción vigente para resolver el select del modal.
exports.InvestigadorUnidadActualSchema = zod_1.z.object({
    idUnidad: zod_1.z.number().int().positive(),
    nombreUnidad: NullableStringSchema,
    nombreAbreviado: NullableStringSchema,
});
exports.InvestigadorDatosPersonalesResponseSchema = zod_1.z.object({
    datos: zod_1.z.array(exports.InvestigadorDatoPersonalSchema),
    unidad: exports.InvestigadorUnidadActualSchema.nullable(),
    // R65: the additional units (principal excluded, principal-first order of the rest). Optional with a
    // default so a client or cache built before the field still passes `Schema.parse` (NFR-06).
    unidadesAdicionales: zod_1.z.array(exports.InvestigadorUnidadActualSchema).optional().default([]),
});
exports.UnidadCatalogoItemSchema = zod_1.z.object({
    idUnidad: zod_1.z.number().int().positive(),
    nombreUnidad: NullableStringSchema,
    nombreAbreviado: NullableStringSchema,
    /** Macrounidad (facultad, centro o instituto) a la que pertenece, o null.
     * La expone el catálogo para poder contar facultades sin depender de que
     * tengan investigadores cargados: la portada informa cuántas TIENE la
     * Universidad, no cuántas alcanzaron a registrar a alguien. */
    idMacrounidad: zod_1.z.number().int().positive().nullable(),
    nombreMacrounidad: NullableStringSchema,
});
exports.UnidadesCatalogoResponseSchema = zod_1.z.object({
    unidades: zod_1.z.array(exports.UnidadCatalogoItemSchema),
});
// ───────────── Adscripción (R65): principal + unidades adicionales ─────────────
/** Longest custom name an "Otra" unit may carry (same limit as onboarding and `AdscripcionService`). */
const MAX_LARGO_NOMBRE_OTRA = 120;
/** `PUT :slug/adscripcion` (admin): the full target state; `nombreOtra` null/absent keeps the stored name. */
exports.UpdateInvestigadorAdscripcionSchema = adscripcion_js_1.EstadoAdscripcionSchema.extend({
    nombreOtra: zod_1.z.string().trim().max(MAX_LARGO_NOMBRE_OTRA).nullable().optional(),
});
/** Response of the admin direct edit: the personal-data read model plus the held lines it closed. */
exports.InvestigadorAdscripcionResponseSchema = exports.InvestigadorDatosPersonalesResponseSchema.extend({
    lineasCerradas: zod_1.z.array(zod_1.z.number().int().positive()).optional().default([]),
});
const AdscripcionUnidadContextoSchema = zod_1.z.object({
    idUnidad: zod_1.z.number().int().positive(),
    nombreUnidad: NullableStringSchema,
    nombreAbreviado: NullableStringSchema,
});
/**
 * `GET :slug/adscripcion`: what the request form, the live preview and the admin panel need. It mirrors
 * `AdscripcionContexto` (API). The pending request's state is read back from storage, so it carries no cap.
 */
exports.AdscripcionContextoResponseSchema = zod_1.z.object({
    principal: AdscripcionUnidadContextoSchema.nullable(),
    adicionales: zod_1.z.array(AdscripcionUnidadContextoSchema),
    lineasActivas: zod_1.z.array(zod_1.z.object({
        idLinea: zod_1.z.number().int().positive(),
        idUnidadDuena: zod_1.z.number().int().positive().nullable(),
        idCentros: zod_1.z.array(zod_1.z.number().int().positive()),
        nombreLinea: NullableStringSchema,
    })),
    solicitudPendiente: zod_1.z
        .object({
        idSolicitud: zod_1.z.number().int().positive(),
        objetivo: zod_1.z.object({
            idUnidadPrincipal: zod_1.z.number().int().positive(),
            idUnidadesAdicionales: zod_1.z.array(zod_1.z.number().int().positive()),
        }),
    })
        .nullable(),
});
exports.CreateInvestigadorDatoPersonalSchema = zod_1.z.object({
    idTipoDatoPersonal: zod_1.z.number().int().positive(),
    valorTexto: zod_1.z.string().trim().min(1).max(2048),
    esPublico: zod_1.z.boolean().optional().default(false),
    ordenVisual: zod_1.z.number().int().optional().default(0),
});
exports.UpdateInvestigadorDatoPersonalSchema = zod_1.z.object({
    valorTexto: zod_1.z.string().trim().min(1).max(2048).optional(),
    esPublico: zod_1.z.boolean().optional(),
    ordenVisual: zod_1.z.number().int().optional(),
});
exports.InvestigadorDatoPersonalIdParamSchema = zod_1.z.object({
    idTipoDatoPersonal: zod_1.z.coerce.number().int().positive(),
    secuencia: zod_1.z.coerce.number().int().positive(),
});
exports.ReorderDatosPersonalesSchema = zod_1.z.object({
    orden: zod_1.z.array(zod_1.z.object({
        idTipoDatoPersonal: zod_1.z.number().int().positive(),
        secuencia: zod_1.z.number().int().positive(),
    })).min(1),
});
// Deshacer cambios de Información personal. El backend reconcilia por `codigo`:
//   - rut: intacto (nunca entra al revert, de ninguna forma).
//   - correo_cuenta / genero: solo orden + visibilidad (su valor es del registro).
//   - grado / unidad: solo orden (grado deriva de formación; unidad cambia por solicitud).
//   - resto de datos custom: revert completo (alta/edición/baja/orden), PK (idTipo, secuencia).
// `idSolicitudesPrevias` = solicitudes cambio_unidad pendientes al abrir el modal: las
// que NO estén en esa lista se cancelan (una solicitud creada en la sesión se retracta).
exports.RestoreInvestigadorDatosPersonalesSchema = zod_1.z.object({
    snapshot: zod_1.z.array(restoreSnapshotItem(exports.InvestigadorDatoPersonalSchema)),
    idSolicitudesPrevias: zod_1.z.array(zod_1.z.number().int().positive()).default([]),
});
// ───────────── Identidad pública: agregar tipoInvestigador ─────────────
// (los demás campos ya existen arriba en InvestigadorPublicIdentitySchema)
// Basic schema for validating incoming params if needed
exports.InvestigadorSlugParamSchema = zod_1.z.object({
    slug: zod_1.z.string().min(1),
});
exports.InvestigadorEnlaceIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
exports.InvestigadorPublicIdentitySchema = zod_1.z.object({
    idInvestigador: zod_1.z.number(),
    fullName: zod_1.z.string(),
    displayName: zod_1.z.string(),
    emailPublic: NullableStringSchema,
    telefonoPublico: NullableStringSchema,
    orcid: NullableStringSchema,
    wosResearcherId: NullableStringSchema,
    scopusAuthorId: NullableStringSchema,
    unit: NullableStringSchema,
    /** Nombre corto de la unidad, para cuando el completo no entra.
     *  OPCIONAL a propósito: si un payload viejo (o cacheado) no lo trae, el
     *  consumidor cae al nombre completo en vez de fallar el parseo entero. */
    unitShort: NullableStringSchema.optional(),
    // Id de la unidad primaria — para lógica de estructura (p. ej. unidad "Otra").
    idUnidad: zod_1.z.number().int().nullable().optional(),
    macroUnit: NullableStringSchema,
    /** Abreviatura de la macrounidad. Opcional por lo mismo que `unitShort`: un
     *  payload cacheado sin el campo degrada al nombre completo en vez de fallar
     *  el parseo entero. */
    macroUnitShort: NullableStringSchema.optional(),
    // Slug estable de rol_investigador (reemplaza el antiguo enum tipo_investigador) — usar para lógica.
    tipoInvestigador: NullableStringSchema.optional(),
    // Nombre legible de rol_investigador — usar para mostrar en el frontend.
    rolInvestigadorNombre: NullableStringSchema.optional(),
    // URL pública de la foto de perfil (AssetStore), o null.
    fotoPerfilUrl: NullableStringSchema.optional(),
    // true si la foto está oculta (privada): la URL se entrega igual, pero sólo el dueño/admin la cargan.
    fotoPerfilOculta: zod_1.z.boolean().optional().default(false),
    // Partes del nombre + formato elegido — solo para prefill del editor (el público ya ve fullName/displayName).
    nombre1: NullableStringSchema.optional(),
    nombre2: NullableStringSchema.optional(),
    apellido1: NullableStringSchema.optional(),
    apellido2: NullableStringSchema.optional(),
    formatoNombre: NullableStringSchema.optional(),
});
exports.InvestigadorPublicPerfilSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    biografia: NullableStringSchema,
    ciudadPublica: NullableStringSchema,
    paisPublico: NullableStringSchema,
    perfilValidado: zod_1.z.boolean(),
    idCargoMostrado: NullableNumberSchema.optional().default(null),
    idFormacionMostrada: NullableNumberSchema.optional().default(null),
});
exports.SetRolMostradoSchema = zod_1.z.object({
    idCargoMostrado: zod_1.z.number().int().positive().nullable(),
    idFormacionMostrada: zod_1.z.number().int().positive().nullable(),
});
exports.RolMostradoResponseSchema = zod_1.z.object({
    idCargoMostrado: NullableNumberSchema,
    idFormacionMostrada: NullableNumberSchema,
});
// ───────────── Foto de perfil (AssetStore) ─────────────
exports.FotoPerfilResponseSchema = zod_1.z.object({
    fotoPerfilUrl: NullableStringSchema,
    // URL de la foto original sin recortar (privada) — para reencuadrar. null si no hay.
    originalUrl: NullableStringSchema.optional().default(null),
    privacidad: NullableStringSchema,
});
exports.InvestigadorPublicUnidadSchema = zod_1.z.object({
    idUnidad: zod_1.z.number(),
    nombreUnidad: NullableStringSchema,
    nombreAbreviado: NullableStringSchema,
    macrounidad: NullableStringSchema,
    fechaAdscripcion: zod_1.z.string(),
    // R65: optional with a default so a stale ISR entry (built before the field) still parses.
    esPrincipal: zod_1.z.boolean().optional().default(false),
});
exports.InvestigadorPublicLineaSchema = zod_1.z.object({
    idLinea: zod_1.z.number(),
    nombreLinea: NullableStringSchema,
    unidad: NullableStringSchema,
    areaOcde: NullableStringSchema,
    subareaOcde: NullableStringSchema,
    areaSies: NullableStringSchema,
    fechaAdscripcion: zod_1.z.string(),
    // R65: the unit that owns the line, its abbreviation, and the names of the units that back the line for
    // THIS researcher (the label shown only when their lines span several units). All with defaults so a stale
    // ISR entry (built before the fields) still parses.
    idUnidad: NullableNumberSchema.optional().default(null),
    unidadAbreviada: NullableStringSchema.optional().default(null),
    unidadesEtiqueta: zod_1.z.array(zod_1.z.string()).optional().default([]),
});
// ── Líneas de investigación: catálogo + selección (modal unificado) ──────────
// Una línea apunta (vía FK nullable) a un área OCDE y un área SIES. La subárea
// OCDE NO existe como relación real todavía: los campos quedan preparados y
// nullable para no inferir nada hasta que la DB modele el vínculo.
exports.InvestigadorLineaOptionSchema = zod_1.z.object({
    idLinea: zod_1.z.number(),
    nombreLinea: NullableStringSchema,
    idUnidad: NullableNumberSchema,
    nombreUnidad: NullableStringSchema,
    // R65: compact unit name for the lines modal when it must show each line's unit (several active
    // units). Optional with a default so an older payload still parses.
    nombreUnidadAbreviado: NullableStringSchema.optional().default(null),
    // R65: names of the units that back a HELD line for this researcher (owner when it is an active unit,
    // otherwise the offering centros they hold). Filled on `seleccionadas` only; [] elsewhere.
    unidadesEtiqueta: zod_1.z.array(zod_1.z.string()).optional().default([]),
    grupoLinea: NullableStringSchema,
    idAreaOcde: NullableNumberSchema,
    nombreAreaOcde: NullableStringSchema,
    idSubareaOcde: NullableNumberSchema,
    nombreSubareaOcde: NullableStringSchema,
    idAreaSies: NullableNumberSchema,
    nombreAreaSies: NullableStringSchema,
    // true cuando el backend indica que el front debe mostrar la unidad de origen
    // junto a la línea (centros/institutos resueltos vía lineas_centro).
    mostrarUnidad: zod_1.z.boolean(),
});
// R66: one saved custom line (free text, no relation to the catalog).
exports.InvestigadorLineaPersonalizadaSchema = zod_1.z.object({
    idLineaPersonalizada: zod_1.z.number().int().positive(),
    texto: zod_1.z.string(),
});
exports.InvestigadorLineasStateResponseSchema = zod_1.z.object({
    disponibles: zod_1.z.array(exports.InvestigadorLineaOptionSchema),
    seleccionadas: zod_1.z.array(exports.InvestigadorLineaOptionSchema),
    // R66: the researcher's custom lines in the order saved. Default so an older payload still parses.
    personalizadas: zod_1.z.array(exports.InvestigadorLineaPersonalizadaSchema).optional().default([]),
});
exports.UpdateInvestigadorLineasSchema = zod_1.z.object({
    // The ORDER is meaningful: it is the manual order of the institutional lines the researcher wants (the service
    // stores each line's position when it differs from the one shown). Custom lines below work the same way.
    idLineas: zod_1.z.array(zod_1.z.number().int().positive()),
    // R66: the FULL desired list of custom lines (cap `MAX_LINEAS_PERSONALIZADAS` x 150). Absent = leave the saved
    // ones untouched. A line with an id updates that row, one without an id is created, a saved id that is missing
    // is deleted. The schema only bounds the payload by the OLD cap (a profile saved under it must still be able to
    // send its state back); the service applies the real cap against the stored count.
    personalizadas: zod_1.z
        .array(lineas_display_js_1.LineaPersonalizadaInputSchema)
        .max(lineas_display_js_1.MAX_LINEAS_PERSONALIZADAS_HISTORICO, `Puedes tener como máximo ${lineas_display_js_1.MAX_LINEAS_PERSONALIZADAS} líneas personalizadas.`)
        .optional(),
});
exports.InvestigadorPublicFormacionSchema = zod_1.z.object({
    id: zod_1.z.number(),
    categoria: zod_1.z.string(),
    tituloObtenido: zod_1.z.string(),
    institucion: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    tesisTitulo: NullableStringSchema,
    descripcion: NullableStringSchema,
    ordenVisual: zod_1.z.number(),
    // Visibilidad de la fila. En la respuesta pública siempre es `true` (las privadas
    // se filtran en el backend); solo `perfil-completo` puede traer `false`. Es opcional
    // con default `true` para tolerar respuestas ISR cacheadas anteriores a este campo:
    // una entrada stale degrada a "pública" en vez de romper el render con un ZodError.
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.InvestigadorPublicExperienciaSchema = zod_1.z.object({
    id: zod_1.z.number(),
    categoria: zod_1.z.string(),
    cargo: zod_1.z.string(),
    institucion: NullableStringSchema,
    unidad: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    jornadaTexto: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean(),
    descripcion: NullableStringSchema,
    ordenVisual: zod_1.z.number(),
    // Visibilidad de la fila. En la respuesta pública siempre es `true` (las privadas
    // se filtran en el backend); solo `perfil-completo` puede traer `false`. Es opcional
    // con default `true` para tolerar respuestas ISR cacheadas anteriores a este campo:
    // una entrada stale degrada a "pública" en vez de romper el render con un ZodError.
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.InvestigadorPublicCapitalHumanoSchema = zod_1.z.object({
    id: zod_1.z.number(),
    nombrePersona: zod_1.z.string(),
    tituloTrabajo: NullableStringSchema,
    tipoParticipacion: zod_1.z.string(),
    nivelFormacion: zod_1.z.string(),
    institucion: NullableStringSchema,
    unidadAcademica: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    anio: NullableNumberSchema,
    descripcion: NullableStringSchema,
    ordenVisual: zod_1.z.number(),
    // Visibilidad de la fila. En la respuesta pública siempre es `true` (las privadas
    // se filtran en el backend); solo `perfil-completo` puede traer `false`. Es opcional
    // con default `true` para tolerar respuestas ISR cacheadas anteriores a este campo:
    // una entrada stale degrada a "pública" en vez de romper el render con un ZodError.
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.InvestigadorPublicPremioSchema = zod_1.z.object({
    id: zod_1.z.number(),
    nombrePremio: zod_1.z.string(),
    institucionOtorgante: NullableStringSchema,
    descripcion: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    anio: NullableNumberSchema,
    ordenVisual: zod_1.z.number(),
    // Visibilidad de la fila. En la respuesta pública siempre es `true` (las privadas
    // se filtran en el backend); solo `perfil-completo` puede traer `false`. Es opcional
    // con default `true` para tolerar respuestas ISR cacheadas anteriores a este campo:
    // una entrada stale degrada a "pública" en vez de romper el render con un ZodError.
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.InvestigadorPublicCargoSchema = zod_1.z.object({
    id: zod_1.z.number(),
    cargoNombre: zod_1.z.string(),
    tipoCargo: TipoCargoSchema,
    ambitoCargo: zod_1.z.string(),
    entidadTexto: NullableStringSchema,
    unidad: NullableStringSchema,
    macrounidad: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    ordenVisual: zod_1.z.number(),
    // Visibilidad de la fila. En la respuesta pública siempre es `true` (las privadas
    // se filtran en el backend); solo `perfil-completo` puede traer `false`. Es opcional
    // con default `true` para tolerar respuestas ISR cacheadas anteriores a este campo:
    // una entrada stale degrada a "pública" en vez de romper el render con un ZodError.
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.InvestigadorPublicActividadSchema = zod_1.z.object({
    id: zod_1.z.number(),
    categoriaActividad: zod_1.z.string(),
    titulo: zod_1.z.string(),
    institucion: NullableStringSchema,
    descripcion: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    ordenVisual: zod_1.z.number(),
    // Visibilidad de la fila. En la respuesta pública siempre es `true` (las privadas
    // se filtran en el backend); solo `perfil-completo` puede traer `false`. Es opcional
    // con default `true` para tolerar respuestas ISR cacheadas anteriores a este campo:
    // una entrada stale degrada a "pública" en vez de romper el render con un ZodError.
    esPublico: zod_1.z.boolean().optional().default(true),
});
exports.InvestigadorEditableActividadSchema = zod_1.z.object({
    id: zod_1.z.number(),
    categoriaActividad: CategoriaActividadSchema,
    titulo: zod_1.z.string(),
    institucion: NullableStringSchema,
    descripcion: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number(),
});
exports.InvestigadorActividadesResponseSchema = zod_1.z.object({
    actividades: zod_1.z.array(exports.InvestigadorEditableActividadSchema),
});
exports.InvestigadorEditablePremioSchema = zod_1.z.object({
    id: zod_1.z.number(),
    nombrePremio: zod_1.z.string(),
    institucionOtorgante: NullableStringSchema,
    descripcion: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    anio: NullableNumberSchema,
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number(),
});
exports.InvestigadorPremiosResponseSchema = zod_1.z.object({
    premios: zod_1.z.array(exports.InvestigadorEditablePremioSchema),
});
// Deshacer cambios: snapshot con que se abrió el modal de premios.
exports.RestoreInvestigadorPremiosSchema = zod_1.z.object({
    snapshot: zod_1.z.array(restoreSnapshotItem(exports.InvestigadorEditablePremioSchema)),
});
exports.InvestigadorEditableCapitalHumanoSchema = zod_1.z.object({
    id: zod_1.z.number(),
    nombrePersona: zod_1.z.string(),
    tituloTrabajo: NullableStringSchema,
    tipoParticipacion: TipoParticipacionCapitalHumanoSchema,
    nivelFormacion: NivelFormacionCapitalHumanoSchema,
    institucion: NullableStringSchema,
    unidadAcademica: NullableStringSchema,
    descripcion: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    anio: NullableNumberSchema,
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number(),
});
exports.InvestigadorCapitalHumanoResponseSchema = zod_1.z.object({
    capitalHumano: zod_1.z.array(exports.InvestigadorEditableCapitalHumanoSchema),
});
// Deshacer cambios: snapshot con que se abrió el modal de capital humano.
// `restoreSnapshotItem` acepta la ausencia de cualquier campo nullable (incluido
// `anio`, que el modal ni siquiera expone) y la coalesce a `null`.
exports.RestoreInvestigadorCapitalHumanoSchema = zod_1.z.object({
    snapshot: zod_1.z.array(restoreSnapshotItem(exports.InvestigadorEditableCapitalHumanoSchema)),
});
const AmbitoCargoSchema = zod_1.z.enum([
    'unidad',
    'macrounidad',
    'institucional',
    'otro',
]);
const InvestigadorCargoRawInputSchema = zod_1.z.object({
    cargoNombre: zod_1.z.string().trim().min(1).max(255),
    tipoCargo: TipoCargoSchema,
    ambitoCargo: AmbitoCargoSchema,
    entidadTexto: zod_1.z.string().max(255).optional().nullable(),
    fechaInicio: zod_1.z.string().date().optional().nullable(),
    fechaTermino: zod_1.z.string().date().optional().nullable(),
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    esPublico: zod_1.z.boolean().optional().default(true),
}).refine((data) => data.enCurso || Boolean(data.fechaTermino), {
    message: 'La fecha de término es requerida salvo que el cargo siga activo',
    path: ['fechaTermino'],
}).refine(fecha_precision_js_1.rangoFechasValido, {
    message: 'La fecha de término debe ser posterior o igual a la fecha de inicio',
    path: ['fechaTermino'],
});
exports.CreateInvestigadorCargoSchema = InvestigadorCargoRawInputSchema;
exports.UpdateInvestigadorCargoSchema = InvestigadorCargoRawInputSchema;
exports.InvestigadorCargoIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
exports.InvestigadorEditableCargoSchema = zod_1.z.object({
    id: zod_1.z.number(),
    cargoNombre: zod_1.z.string(),
    tipoCargo: TipoCargoSchema,
    ambitoCargo: AmbitoCargoSchema,
    entidadTexto: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number(),
});
// AlertaGenerada: summary returned in mutation responses so the frontend can toast
exports.AlertaGeneradaSchema = zod_1.z.object({
    tipoAlerta: zod_1.z.string(),
    severidad: zod_1.z.enum(['info', 'aviso', 'critico']),
    titulo: zod_1.z.string(),
    mensaje: zod_1.z.string(),
});
exports.InvestigadorCargosResponseSchema = zod_1.z.object({
    cargos: zod_1.z.array(exports.InvestigadorEditableCargoSchema),
    alertasGeneradas: zod_1.z.array(exports.AlertaGeneradaSchema).optional().default([]),
    // Estamento actual del investigador. El modal lo captura al abrir para poder
    // reponerlo en el "deshacer cambios" (declarar un cargo activo de mayor rango
    // promueve el estamento; el undo debe volver a este valor de apertura).
    idEstamentoActual: zod_1.z.number().int().positive().nullable().optional().default(null),
    // Slug del estamento actual (directivo|academico|funcionario). Lo usa el frontend
    // para el toast informativo cuando el estamento cambia por un cargo.
    estamentoActualSlug: zod_1.z.string().nullable().optional().default(null),
    // Nombre legible del estamento actual (= estamento.nombre / rolInvestigadorNombre). El
    // frontend lo usa como fallback VIVO del "rol de abajo" cuando no hay cargo/formación
    // elegida, en vez del prop de servidor `investigator.rolInvestigadorNombre` (que queda viejo).
    estamentoActualNombre: zod_1.z.string().nullable().optional().default(null),
    // Cargo elegido como "rol mostrado" bajo el nombre. El backend lo auto-asigna al
    // declarar un cargo activo sin rol previo; el frontend sincroniza su estado y avisa.
    idCargoMostrado: zod_1.z.number().int().positive().nullable().optional().default(null),
    // Alertas rol_basico de cargos abiertas (pendiente/en_revision). El modal las congela al
    // abrir para que el deshacer descarte solo las de la sesión.
    idAlertasRolBasicoPendientes: zod_1.z.array(zod_1.z.number().int().positive()).optional().default([]),
});
// Deshacer cambios: snapshot de cargos + el estamento con que se abrió el modal.
// El backend reconcilia cargos → snapshot, repone `idEstamentoApertura` y descarta
// la alerta rol_basico de los cargos borrados (ver InvestigadorCargosService).
exports.RestoreInvestigadorCargosSchema = zod_1.z.object({
    snapshot: zod_1.z.array(restoreSnapshotItem(exports.InvestigadorEditableCargoSchema)),
    idEstamentoApertura: zod_1.z.number().int().positive().nullable(),
    // Alertas rol_basico que ya estaban pendientes al abrir el modal. El deshacer descarta
    // solo las creadas en la sesión (las que NO están acá); las de apertura se preservan.
    idAlertasPrevias: zod_1.z.array(zod_1.z.number().int().positive()).default([]),
});
const CategoriaExperienciaSchema = zod_1.z.enum([
    'academica',
    'profesional',
    'gestion_universitaria',
    'investigacion',
    'extension',
    'otro',
]);
const InvestigadorExperienciaRawInputSchema = zod_1.z.object({
    categoriaExperiencia: CategoriaExperienciaSchema,
    cargo: zod_1.z.string().trim().min(1).max(255),
    institucion: zod_1.z.string().max(255).optional().nullable(),
    unidad: zod_1.z.string().max(255).optional().nullable(),
    pais: zod_1.z.string().max(128).optional().nullable(),
    ciudad: zod_1.z.string().max(128).optional().nullable(),
    jornadaTexto: zod_1.z.string().max(128).optional().nullable(),
    fechaInicio: zod_1.z.string().date().optional().nullable(),
    fechaTermino: zod_1.z.string().date().optional().nullable(),
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    descripcion: zod_1.z.string().optional().nullable(),
    esPublico: zod_1.z.boolean().optional().default(true),
}).refine((data) => data.enCurso || Boolean(data.fechaTermino), {
    message: 'La fecha de término es requerida salvo que el cargo sea actual',
    path: ['fechaTermino'],
});
exports.CreateInvestigadorExperienciaSchema = InvestigadorExperienciaRawInputSchema;
exports.UpdateInvestigadorExperienciaSchema = InvestigadorExperienciaRawInputSchema;
exports.InvestigadorExperienciaIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
exports.InvestigadorEditableExperienciaSchema = zod_1.z.object({
    id: zod_1.z.number(),
    categoriaExperiencia: CategoriaExperienciaSchema,
    cargo: zod_1.z.string(),
    institucion: NullableStringSchema,
    unidad: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    jornadaTexto: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    descripcion: NullableStringSchema,
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number(),
});
exports.InvestigadorExperienciaResponseSchema = zod_1.z.object({
    experiencias: zod_1.z.array(exports.InvestigadorEditableExperienciaSchema),
});
// Deshacer cambios: snapshot con que se abrió el modal de experiencia.
exports.RestoreInvestigadorExperienciaSchema = zod_1.z.object({
    snapshot: zod_1.z.array(restoreSnapshotItem(exports.InvestigadorEditableExperienciaSchema)),
});
const CategoriaFormacionSchema = zod_1.z.enum([
    'pregrado',
    'postitulo',
    'diplomado',
    'especialidad',
    'magister',
    'doctorado',
    'postdoctorado',
    'capacitacion',
    'certificacion',
    'otro',
]);
const InvestigadorFormacionRawInputSchema = zod_1.z.object({
    categoriaFormacion: CategoriaFormacionSchema,
    tituloObtenido: zod_1.z.string().trim().min(1).max(500),
    institucion: zod_1.z.string().trim().min(1).max(255),
    pais: zod_1.z.string().trim().min(1).max(128),
    ciudad: zod_1.z.string().max(128).optional().nullable(),
    fechaInicio: zod_1.z.string().date(),
    fechaTermino: zod_1.z.string().date().optional().nullable(),
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionInputSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    tesisTitulo: zod_1.z.string().max(700).optional().nullable(),
    descripcion: zod_1.z.string().optional().nullable(),
    esPublico: zod_1.z.boolean().optional().default(true),
}).refine((data) => data.enCurso || Boolean(data.fechaTermino), {
    message: 'La fecha de término es requerida salvo que la formación esté en curso',
    path: ['fechaTermino'],
}).refine(fecha_precision_js_1.rangoFechasValido, {
    message: 'La fecha de término debe ser posterior o igual a la fecha de inicio',
    path: ['fechaTermino'],
});
exports.CreateInvestigadorFormacionSchema = InvestigadorFormacionRawInputSchema;
exports.UpdateInvestigadorFormacionSchema = InvestigadorFormacionRawInputSchema;
exports.ReorderInvestigadorFormacionSchema = zod_1.z.object({
    orden: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
exports.InvestigadorFormacionIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
exports.InvestigadorEditableFormacionSchema = zod_1.z.object({
    id: zod_1.z.number(),
    categoriaFormacion: CategoriaFormacionSchema,
    tituloObtenido: zod_1.z.string(),
    institucion: NullableStringSchema,
    pais: NullableStringSchema,
    ciudad: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    fechaInicioPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    fechaTerminoPrecision: fecha_precision_js_1.FechaPrecisionResponseSchema,
    enCurso: zod_1.z.boolean().optional().default(false),
    tesisTitulo: NullableStringSchema,
    descripcion: NullableStringSchema,
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number(),
});
exports.InvestigadorFormacionResponseSchema = zod_1.z.object({
    formaciones: zod_1.z.array(exports.InvestigadorEditableFormacionSchema),
    // Formación auto-seleccionada como "rol mostrado" (la terminada pública de mayor grado, de
    // las 3 categorías). El frontend sincroniza displayedFormacionId para reflejarla sin recargar.
    idFormacionMostrada: zod_1.z.number().int().positive().nullable().optional().default(null),
});
// Deshacer cambios: snapshot con que se abrió el modal de formación académica.
exports.RestoreInvestigadorFormacionSchema = zod_1.z.object({
    snapshot: zod_1.z.array(restoreSnapshotItem(exports.InvestigadorEditableFormacionSchema)),
});
exports.InvestigadorPublicEnlaceSchema = zod_1.z.object({
    id: zod_1.z.number(),
    tipoEnlace: TipoEnlaceSchema,
    etiqueta: NullableStringSchema,
    url: zod_1.z.string(),
    esPublico: zod_1.z.boolean().optional(),
    ordenVisual: zod_1.z.number(),
});
exports.InvestigadorEditableEnlaceSchema = zod_1.z.object({
    id: zod_1.z.number(),
    tipoEnlace: TipoEnlaceSchema,
    etiqueta: NullableStringSchema,
    url: zod_1.z.string(),
    esPublico: zod_1.z.boolean(),
    ordenVisual: zod_1.z.number(),
});
exports.InvestigadorEnlacesExternosResponseSchema = zod_1.z.object({
    enlaces: zod_1.z.array(exports.InvestigadorEditableEnlaceSchema),
});
exports.InvestigadorPublicacionSchema = zod_1.z.object({
    id: zod_1.z.number(),
    titulo: zod_1.z.string(),
    tipo: zod_1.z.string(),
    // R67: EFFECTIVE year = COALESCE(año_publicacion, YEAR(fecha_early_access)) (see
    // `anioEfectivoPublicacion`); null only when both are missing (UI shows «Sin año»).
    anio: zod_1.z.number().nullable(),
    /** true when `anio` comes from the early-access date (no definitive year yet). */
    anioEarlyAccess: zod_1.z.boolean().optional().default(false),
    doi: NullableStringSchema,
    journal: NullableStringSchema,
    wosId: NullableStringSchema,
    scopusId: NullableStringSchema,
    esAutorCorrespondiente: zod_1.z.boolean(),
    numeroAutor: zod_1.z.number().nullable(),
});
exports.InvestigadorProyectoSchema = zod_1.z.object({
    id: zod_1.z.number(),
    tipo: zod_1.z.enum(['interno', 'externo']),
    titulo: NullableStringSchema,
    codigo: NullableStringSchema,
    estado: NullableStringSchema,
    rol: NullableStringSchema,
    fechaInicio: NullableStringSchema,
    fechaTermino: NullableStringSchema,
    montoAdjudicado: NullableNumberSchema,
    activo: NullableBooleanSchema,
});
exports.InvestigadorPublicCvSchema = zod_1.z.object({
    formacion: zod_1.z.array(exports.InvestigadorPublicFormacionSchema),
    experiencia: zod_1.z.array(exports.InvestigadorPublicExperienciaSchema),
    capitalHumano: zod_1.z.array(exports.InvestigadorPublicCapitalHumanoSchema),
    premios: zod_1.z.array(exports.InvestigadorPublicPremioSchema),
    cargos: zod_1.z.array(exports.InvestigadorPublicCargoSchema),
    actividades: zod_1.z.array(exports.InvestigadorPublicActividadSchema),
    enlaces: zod_1.z.array(exports.InvestigadorPublicEnlaceSchema),
});
// Dato personal expuesto en el perfil público: solo los `esPublico=true`.
// `anchoColumnas` (1..3) es propiedad del tipo y define cuántas columnas ocupa
// en el grid de 3 columnas de Información Personal.
exports.DatoPersonalPublicoSchema = zod_1.z.object({
    codigo: zod_1.z.string(),
    etiqueta: zod_1.z.string(),
    valor: zod_1.z.string(),
    tipoValor: TipoValorDatoPersonalSchema,
    anchoColumnas: zod_1.z.number().int().min(1).max(3),
    ordenVisual: zod_1.z.number().int(),
    // Ver la nota de `esPublico` en los schemas del CV: en la respuesta pública
    // siempre es `true`, y el default tolera entradas ISR anteriores al campo.
    esPublico: zod_1.z.boolean().optional().default(true),
    // Afiliación (tooltip): macrounidad (facultad) de la unidad que espeja una fila `unidad` / `unidad_adicional`;
    // null en cualquier otro dato y en una unidad sin macrounidad ("Otra"). El default tolera entradas ISR
    // anteriores al campo.
    macrounidad: NullableStringSchema.optional().default(null),
});
exports.InvestigadorPublicProfileResponseSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    // R12 (SEO): whether search engines may index this profile. A `no_listado`
    // profile is reachable by direct link but must never enter the index, and the
    // web app cannot tell the two apart on its own — `visibilidadPublica` is
    // resolved API-side and never leaves it. `.default(true)` keeps an ISR entry
    // cached before this field existed rendering as it already did (indexable)
    // instead of blowing up with a ZodError; the deploy revalidates the public
    // cache, so that window closes on release.
    indexable: zod_1.z.boolean().optional().default(true),
    investigator: exports.InvestigadorPublicIdentitySchema,
    perfil: exports.InvestigadorPublicPerfilSchema,
    unidades: zod_1.z.array(exports.InvestigadorPublicUnidadSchema),
    lineas: zod_1.z.array(exports.InvestigadorPublicLineaSchema),
    // R66: custom lines as plain texts in the order saved. Default so a stale ISR entry still parses.
    lineasPersonalizadas: zod_1.z.array(zod_1.z.string()).optional().default([]),
    cv: exports.InvestigadorPublicCvSchema,
    // `.default([])` tolera respuestas cacheadas (ISR) anteriores a la incorporación
    // de este campo: una entrada stale sin la key degrada a lista vacía en vez de
    // romper el render del perfil con un ZodError.
    datosPersonales: zod_1.z.array(exports.DatoPersonalPublicoSchema).default([]),
    publicaciones: zod_1.z.array(exports.InvestigadorPublicacionSchema),
    proyectos: zod_1.z.array(exports.InvestigadorProyectoSchema),
});
/**
 * El perfil TAL COMO LO NECESITA EL DIRECTORIO, que no es el mismo que el del
 * perfil individual y por eso no reusa su schema.
 *
 * La diferencia que motiva la separación es `biografia`. En el directorio viajan
 * 270 perfiles de una vez, y la biografía NO se usa en esa vista: sólo la
 * consume la página del perfil, que pega a otro endpoint. Medido sobre el payload
 * real (209 KB), con biografías de 800 caracteres el directorio DUPLICARÍA de
 * tamaño — y se paga dos veces, una del API a Next y otra de Next al navegador,
 * porque el listado viaja como prop de un componente cliente. Lo que el
 * directorio necesita saber es si HAY biografía, para poder filtrar por perfiles
 * con contenido real: eso es un booleano.
 */
exports.InvestigadorDirectoryPerfilSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    ciudadPublica: NullableStringSchema,
    paisPublico: NullableStringSchema,
    perfilValidado: zod_1.z.boolean(),
    // Los tres campos siguientes llevan `.default()` por la misma razón que
    // `indexable` en el perfil: una entrada ISR cacheada ANTES de que existieran
    // tiene que degradar a un valor sensato en vez de romper el render entero con
    // un ZodError. El deploy revalida el caché público, así que la ventana se
    // cierra en el release.
    tieneBiografia: zod_1.z.boolean().optional().default(false),
    /** Publicaciones con autoría registrada. Mismo criterio que usa el perfil. */
    publicacionesCount: zod_1.z.number().int().optional().default(0),
    /** Año de la publicación más reciente, o null si no tiene ninguna. */
    ultimoAnioPublicacion: NullableNumberSchema.optional().default(null),
    /**
     * ISO timestamp of the last real change to what the public profile shows, or null
     * when none is known. Feeds the sitemap `lastmod`; it under-reports on purpose
     * (see `perfil-ultima-modificacion.ts` in the API). Default for stale cache entries.
     */
    actualizadoEn: NullableStringSchema.optional().default(null),
});
exports.InvestigadorDirectoryItemSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    investigator: exports.InvestigadorPublicIdentitySchema,
    perfil: exports.InvestigadorDirectoryPerfilSchema,
    lineas: zod_1.z.array(exports.InvestigadorPublicLineaSchema),
    // R66: custom lines as plain texts (directory search / filter, W12). Default for stale cache entries.
    lineasPersonalizadas: zod_1.z.array(zod_1.z.string()).optional().default([]),
});
exports.InvestigadorDirectoryResponseSchema = zod_1.z.array(exports.InvestigadorDirectoryItemSchema);
// ───────────── Admin: visibilidad de perfiles (R37 / R52) ─────────────
// Estados de visibilidad del perfil. `publico` aparece en el directorio;
// `no_listado` es alcanzable por link directo pero no se lista; `solo_uda` y
// `privado` no se exponen en la ruta pública anónima. El directorio admin ve
// los cuatro estados para poder gestionarlos.
exports.VisibilidadPublicaSchema = zod_1.z.enum(['publico', 'no_listado', 'solo_uda', 'privado']);
// Fila de la tabla admin de investigadores (R37): identidad mínima + unidad +
// estamento + estado de visibilidad. No incluye datos sensibles del CV.
exports.AdminInvestigadorItemSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    idInvestigador: zod_1.z.number(),
    displayName: zod_1.z.string(),
    fullName: zod_1.z.string(),
    correo: NullableStringSchema,
    unit: NullableStringSchema,
    macroUnit: NullableStringSchema,
    tipoInvestigador: NullableStringSchema,
    rolInvestigadorNombre: NullableStringSchema,
    visibilidadPublica: exports.VisibilidadPublicaSchema,
    perfilValidado: zod_1.z.boolean(),
    // Partes del nombre (para el editor de nombre del modal admin).
    nombre1: NullableStringSchema,
    nombre2: NullableStringSchema,
    apellido1: NullableStringSchema,
    apellido2: NullableStringSchema,
    formatoNombre: NullableStringSchema,
});
exports.AdminInvestigadorListResponseSchema = zod_1.z.array(exports.AdminInvestigadorItemSchema);
// Body del PATCH admin de visibilidad (R52).
exports.SetInvestigadorVisibilidadSchema = zod_1.z.object({
    visibilidad: exports.VisibilidadPublicaSchema,
});
// Respuesta del PATCH: slug + el nuevo estado (el front actualiza la fila).
exports.AdminVisibilidadUpdateResponseSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    visibilidadPublica: exports.VisibilidadPublicaSchema,
});
// ───────────── Solicitudes (approval-request flow) ─────────────
exports.CreateSolicitudCambioUnidadDetallesSchema = zod_1.z.object({
    unidadActualId: zod_1.z.number().int().positive().optional().nullable(),
    unidadSolicitadaId: zod_1.z.number().int().positive(),
    motivo: zod_1.z.string().max(1000).optional().nullable(),
});
/**
 * `adscripcion` of a combined `cambio_unidad` request: only the state the researcher asks for. The server
 * derives the items from the current state and never trusts items sent by the client.
 */
exports.CreateSolicitudAdscripcionSchema = zod_1.z.object({
    objetivo: adscripcion_js_1.EstadoAdscripcionSchema,
    nombreOtra: zod_1.z.string().trim().max(MAX_LARGO_NOMBRE_OTRA).nullable().optional(),
    /**
     * Why the researcher asks for each structural change, keyed by item id (`principal`, `agregar-<id>`, `quitar-<id>`).
     * Optional here because the items are derived on the server; the service refuses the request when an item that asks
     * for a reason has none, and ignores keys that are not items.
     */
    motivos: zod_1.z.record(zod_1.z.string(), zod_1.z.string().trim().max(adscripcion_js_1.MOTIVO_ITEM_MAX_LARGO)).optional(),
});
/**
 * Create a `cambio_unidad` request. Two shapes, exactly one per call:
 *  - legacy `detalles` (`unidadSolicitadaId`): "change my principal to X" (the old modal);
 *  - `adscripcion { objetivo, nombreOtra? }`: the combined target state (principal + additional units).
 * `idInvestigador` is optional: the server resolves it from the session and, when present, refuses one
 * that is not the caller's own (UAR-07).
 */
exports.CreateSolicitudSchema = zod_1.z
    .object({
    tipoSolicitud: zod_1.z.literal('cambio_unidad'),
    idInvestigador: zod_1.z.number().int().positive().optional(),
    detalles: exports.CreateSolicitudCambioUnidadDetallesSchema.optional(),
    adscripcion: exports.CreateSolicitudAdscripcionSchema.optional(),
    /** Required for the legacy `detalles` shape; a combined request carries its reasons in `adscripcion.motivos` instead. */
    justificacion: zod_1.z.string().trim().min(1).max(2000).optional(),
})
    .refine((solicitud) => (solicitud.detalles === undefined) !== (solicitud.adscripcion === undefined), {
    message: 'Indica el cambio de unidad con `detalles` o con `adscripcion`, pero no con ambos.',
    path: ['adscripcion'],
})
    .refine((solicitud) => solicitud.adscripcion !== undefined || solicitud.justificacion !== undefined, {
    message: 'Escribe la justificación de la solicitud.',
    path: ['justificacion'],
});
exports.SolicitudUsuarioInfoSchema = zod_1.z.object({
    idUsuario: zod_1.z.number().int().positive(),
    correo: zod_1.z.string(),
    nombre: zod_1.z.string().nullable(),
});
exports.SolicitudResponseSchema = zod_1.z.object({
    idSolicitud: zod_1.z.number().int().positive(),
    tipoSolicitud: zod_1.z.string(),
    estado: zod_1.z.string(),
    prioridad: zod_1.z.string(),
    origen: zod_1.z.string(),
    objetoTipo: zod_1.z.string().nullable(),
    objetoId: zod_1.z.number().nullable(),
    titulo: zod_1.z.string(),
    descripcion: zod_1.z.string(),
    detallesJson: zod_1.z.string().nullable(),
    idUsuario: zod_1.z.number().nullable(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string().nullable(),
    closedAt: zod_1.z.string().nullable(),
    // Optional admin-facing fields — populated by admin list/update endpoints.
    usuario: exports.SolicitudUsuarioInfoSchema.nullable().optional(),
    investigadorSlug: zod_1.z.string().nullable().optional(),
    respuestaAdmin: zod_1.z.string().nullable().optional(),
    handledByUserId: zod_1.z.number().nullable().optional(),
    // R65: ids of the pending requests this one replaced, and (on a replaced request) the id of its
    // replacement. A request is "Reemplazada" when `estado === 'rechazada' && reemplazadaPor != null`.
    reemplazadas: zod_1.z.array(zod_1.z.number().int().positive()).optional().default([]),
    reemplazadaPor: zod_1.z.number().int().positive().nullable().optional().default(null),
    // R65: the parsed summary of a combined `cambio_unidad` request (state, items and, once resolved, the
    // outcome of each item). Null for other types, for an unreadable payload and for a legacy request not yet
    // upgraded (its items depend on the researcher's current state, which a list does not carry).
    adscripcion: adscripcion_js_1.SolicitudAdscripcionDetallesSchema.shape.adscripcion
        .extend({
        nombreOtra: zod_1.z.string().nullable().optional().default(null),
        resolucion: adscripcion_js_1.SolicitudAdscripcionDetallesSchema.shape.resolucion.unwrap().nullable().optional().default(null),
    })
        .nullable()
        .optional()
        .default(null),
});
exports.SolicitudesListResponseSchema = zod_1.z.object({
    solicitudes: zod_1.z.array(exports.SolicitudResponseSchema),
});
exports.UpdateSolicitudEstadoSchema = zod_1.z.object({
    estado: zod_1.z.enum(['resuelta', 'rechazada']),
    respuestaAdmin: zod_1.z.string().max(2000).optional().nullable(),
    // R65: the admin's per-item outcome for a combined `cambio_unidad` request. An item without a decision
    // is approved; `estado: 'rechazada'` rejects every item whatever is sent here.
    decisiones: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().min(1),
        aprobado: zod_1.z.boolean(),
        motivo: zod_1.z.string().max(500).nullable().optional(),
    }))
        .optional(),
});
// ── Publicaciones (CRUD editable) ────────────────────────────────────────────
// La publicación es una entidad COMPARTIDA. El estamento y la línea del investigador
// viven en la tabla puente `publicacion_investigador_unidad_linea_estamento` (por
// investigador). El permiso de edición/borrado se restringe a las publicaciones
// manuales creadas por el propio usuario (se determina vía `registro_auditoria`).
// Un participante = un investigador UDA ligado a la publicación. Su estamento y línea
// viven en `publicacion_investigador_unidad_linea_estamento`; primer autor (numeroAutor=1)
// y autor correspondiente en `publicacion_investigador_autoria`. La línea sólo la
// fija cada persona en su propio perfil; aquí el editor sólo setea la suya.
const PublicacionParticipanteInputSchema = zod_1.z.object({
    idInvestigador: zod_1.z.number().int().positive(),
    idEstamento: zod_1.z.number().int().positive().nullable().optional(),
    idLinea: zod_1.z.number().int().positive().nullable().optional(),
    esPrimerAutor: zod_1.z.boolean().optional().default(false),
    esAutorCorrespondiente: zod_1.z.boolean().optional().default(false),
});
const InvestigadorPublicacionRawInputSchema = zod_1.z.object({
    // Núcleo (tabla `publicacion`)
    titulo: zod_1.z.string().trim().min(1).max(500),
    doi: zod_1.z.string().max(250).optional().nullable(),
    idTipoPublicacion: zod_1.z.number().int().positive(),
    anoPublicacion: zod_1.z.number().int().min(1900).max(2100),
    fechaPublicacion: zod_1.z.string().date().optional().nullable(),
    fechaEarlyAccess: zod_1.z.string().date().optional().nullable(),
    fechaIndexacion: zod_1.z.string().date().optional().nullable(),
    earlyAccess: zod_1.z.boolean().optional().nullable(),
    fuente: zod_1.z.string().max(512).optional().nullable(),
    colabNacional: zod_1.z.boolean().optional().nullable(),
    colabInternacional: zod_1.z.boolean().optional().nullable(),
    // Revista (todo opcional)
    revistaTitulo: zod_1.z.string().max(250).optional().nullable(),
    volume: zod_1.z.string().max(128).optional().nullable(),
    issue: zod_1.z.string().max(128).optional().nullable(),
    pageStart: zod_1.z.string().max(128).optional().nullable(),
    pageEnd: zod_1.z.string().max(128).optional().nullable(),
    pageCount: zod_1.z.string().max(128).optional().nullable(),
    articleNumber: zod_1.z.string().max(128).optional().nullable(),
    // Identificadores de indexación: el frontend extrae el id desde el link.
    wosId: zod_1.z.string().max(50).optional().nullable(),
    scopusEid: zod_1.z.string().max(200).optional().nullable(),
    scieloPid: zod_1.z.string().max(200).optional().nullable(),
    // País de la colección SciELO (R68), sacado del dominio del link; null si no se reconoce.
    scieloPais: zod_1.z.string().max(64).optional().nullable(),
    // Participación
    participantes: zod_1.z.array(PublicacionParticipanteInputSchema).default([]),
});
exports.CreateInvestigadorPublicacionSchema = InvestigadorPublicacionRawInputSchema;
exports.UpdateInvestigadorPublicacionSchema = InvestigadorPublicacionRawInputSchema;
exports.InvestigadorPublicacionIdParamSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
});
// Reporte de investigador UDA faltante en el dropdown → alerta_sistema.
exports.ReportarInvestigadorFaltanteSchema = zod_1.z.object({
    nombre: zod_1.z.string().trim().min(1).max(255),
    contexto: zod_1.z.string().max(500).optional().nullable(),
});
// Reporte de error en una publicación → alerta_sistema.
exports.ReportarErrorPublicacionSchema = zod_1.z.object({
    mensaje: zod_1.z.string().trim().min(1).max(2000),
});
// Acciones masivas sobre las publicaciones seleccionadas (checkbox).
exports.BulkDeletePublicacionesSchema = zod_1.z.object({
    ids: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
exports.BulkSetLineaPublicacionesSchema = zod_1.z.object({
    ids: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
    idLinea: zod_1.z.number().int().positive().nullable(),
});
exports.BulkSetEstamentoPublicacionesSchema = zod_1.z.object({
    ids: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
    idEstamento: zod_1.z.number().int().positive().nullable(),
});
// Fila liviana para la tabla.
exports.InvestigadorPublicacionRowSchema = zod_1.z.object({
    id: zod_1.z.number(),
    titulo: zod_1.z.string(),
    // R67: EFFECTIVE year = COALESCE(año_publicacion, YEAR(fecha_early_access)) (see
    // `anioEfectivoPublicacion`); null only when both are missing (UI shows «Sin año»).
    anio: zod_1.z.number().nullable(),
    /** true when `anio` comes from the early-access date (no definitive year yet). */
    anioEarlyAccess: zod_1.z.boolean().optional().default(false),
    tipo: zod_1.z.string(),
    idTipoPublicacion: zod_1.z.number(),
    doi: NullableStringSchema,
    idEstamento: NullableNumberSchema,
    idLinea: NullableNumberSchema,
    // R65: unit of the attribution row (fixed once created); null when the researcher has no row yet.
    // Optional with a default so an older payload still parses.
    idUnidadAtribucion: NullableNumberSchema.optional().default(null),
    // true sólo si la creó el usuario actual de forma manual (auditoría).
    puedeEliminar: zod_1.z.boolean(),
    // true si el usuario puede editar todos los datos (la subió él mismo / admin).
    puedeEditar: zod_1.z.boolean(),
});
exports.PublicacionParticipanteDetailSchema = zod_1.z.object({
    idInvestigador: zod_1.z.number(),
    nombre: zod_1.z.string(),
    idEstamento: NullableNumberSchema,
    idLinea: NullableNumberSchema,
    // R65: unit of this participant's attribution row; null when they have none yet.
    idUnidadAtribucion: NullableNumberSchema.optional().default(null),
    esPrimerAutor: zod_1.z.boolean(),
    esAutorCorrespondiente: zod_1.z.boolean(),
});
// Detalle completo (modal de edición / visualización).
exports.InvestigadorPublicacionDetailSchema = zod_1.z.object({
    id: zod_1.z.number(),
    titulo: zod_1.z.string(),
    doi: NullableStringSchema,
    idTipoPublicacion: zod_1.z.number(),
    // R67: nullable on OUTPUT — a bibliometric import may bring no year. Input
    // (`InvestigadorPublicacionRawInputSchema`) still requires it.
    anoPublicacion: zod_1.z.number().nullable(),
    fechaPublicacion: NullableStringSchema,
    fechaEarlyAccess: NullableStringSchema,
    fechaIndexacion: NullableStringSchema,
    earlyAccess: NullableBooleanSchema,
    fuente: NullableStringSchema,
    colabNacional: NullableBooleanSchema,
    colabInternacional: NullableBooleanSchema,
    revistaTitulo: NullableStringSchema,
    volume: NullableStringSchema,
    issue: NullableStringSchema,
    pageStart: NullableStringSchema,
    pageEnd: NullableStringSchema,
    pageCount: NullableStringSchema,
    articleNumber: NullableStringSchema,
    wosId: NullableStringSchema,
    scopusEid: NullableStringSchema,
    scieloPid: NullableStringSchema,
    participantes: zod_1.z.array(exports.PublicacionParticipanteDetailSchema),
    puedeEliminar: zod_1.z.boolean(),
    // Permiso/contexto de edición:
    puedeEditar: zod_1.z.boolean(),
    // Nombre de quien la subió (auditoría); null si no hay registro (p. ej. automática).
    subidoPorNombre: NullableStringSchema,
    // 'WoS' | 'Scopus' si se infiere ingreso automático; null si es manual/desconocido.
    origenAutomatico: NullableStringSchema,
});
exports.InvestigadorEstamentoOptionSchema = zod_1.z.object({
    idEstamento: zod_1.z.number(),
    slug: zod_1.z.string(),
    nombre: zod_1.z.string(),
});
exports.InvestigadorTipoPublicacionOptionSchema = zod_1.z.object({
    idTipoPublicacion: zod_1.z.number(),
    descripcion: zod_1.z.string(),
});
exports.InvestigadorBasicOptionSchema = zod_1.z.object({
    idInvestigador: zod_1.z.number(),
    nombre: zod_1.z.string(),
});
exports.InvestigadorPublicacionesResponseSchema = zod_1.z.object({
    publicaciones: zod_1.z.array(exports.InvestigadorPublicacionRowSchema),
});
exports.InvestigadorPublicacionOptionsResponseSchema = zod_1.z.object({
    idInvestigadorActual: zod_1.z.number(),
    estamentos: zod_1.z.array(exports.InvestigadorEstamentoOptionSchema),
    // Compat: the options for a NEW publication in the current year.
    lineas: zod_1.z.array(exports.InvestigadorLineaOptionSchema),
    // R65: the data the editor needs to compute the options of each publication (year window).
    catalogoLineas: publicacion_lineas_js_1.PublicacionLineasCatalogoSchema.optional().default({ unidadesActuales: [], lineas: [] }),
    tiposPublicacion: zod_1.z.array(exports.InvestigadorTipoPublicacionOptionSchema),
    investigadores: zod_1.z.array(exports.InvestigadorBasicOptionSchema),
});
